import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import SvgIcon from '../common/SvgIcon';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import NumberUtils from '../../utils/NumberUtils';
import StepHeader from '../../includes/StepHeader';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';

class AddCompanySummary extends Component {
  constructor(props) {
    super(props);
    this.showPayeePage = this.showPayeePage.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.goToAccounts = this.goToAccounts.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
    this.state = {
      allPayeeCardInfo: true,
      editPayeePageFlag: false,
    };
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.summaryHeaderTitle);
    window.scrollTo(0, 0);
  }

  getSortCodeDisplayNumber() {
    let sortcode = _.split(this.props.companyData.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    // const accountNumber = this.props.data.account_number;
    return sortcode;
  }

  goToAccounts() {
    MoveMoneyPayeeActionCreator.resetData();
    InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE');
  }

  goToManagePayees() {
    MoveMoneyPayeeStore.resetStore();
    MoveMoneyPayeeStore.resetFlags();

    this.props.goToManagePayees();
  }

  goToMoveMoneyPage() {
    this.props.goToMoveMoneyPage();
  }

  showPayeePage() {
    // call parent method to update flag to call Payee component condition
    this.props.showPayees();
    this.setState({
      allPayeeCardInfo: false,
    });
  }

  render() {
    const {
      getValidCompanyName,
      companyData: { account_number },
      content: {
        companyAddedMsg1,
        makePaymentBtn,
        goAcctBtn,
        goMangePayeeBtn,
        summaryHeaderTitle,
      },
      summaryDetails: { display_name: nickName = '-', reference },
    } = this.props;

    return (
      <div className="payee-summary" id="site-main" tabIndex="-1">
        <StepHeader showheaderCrumbs={false} headerTitle={summaryHeaderTitle} />
        <div className="c-media">
          <div className="c-media__thumb">
            <SvgIcon id="icon-success" width="64px" height="64px" />
          </div>
          <div className="c-media__body">
            <p>
              <strong className="word-break-all">
                {getValidCompanyName()}
              </strong>
              {companyAddedMsg1}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md1-18">
            <dl className="c-definitions">
              <dt className="c-definitions__key">Name</dt>
              <dd className="c-definitions__value" data-test-id="display_name">
                {getValidCompanyName()}
              </dd>

              <dt className="c-definitions__key">Nickname</dt>
              <dd className="c-definitions__value" data-test-id="nickname">
                {nickName}
              </dd>

              <dt className="c-definitions__key">Sort code</dt>
              <dd className="c-definitions__value">
                {this.getSortCodeDisplayNumber()}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">{account_number}</dd>

              <dt className="c-definitions__key">Reference</dt>
              <dd className="c-definitions__value">{reference}</dd>
            </dl>
          </div>
        </div>
        <div className="payee-summary__options">
          <button
            type="button"
            className="c-btn c-btn--default"
            onClick={this.goToMoveMoneyPage}
          >
            {makePaymentBtn}
          </button>
          <br />
          <br />
          <button
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToAccounts}
          >
            {goAcctBtn}
          </button>
          &nbsp;
          <button
            data-test-id="go-to-manage-payees-button"
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToManagePayees}
          >
            {goMangePayeeBtn}
          </button>
        </div>
      </div>
    );
  }
}

AddCompanySummary.propTypes = {
  content: PropTypes.object,
  summaryDetails: PropTypes.object,
  companyData: PropTypes.object,
  goToManagePayees: PropTypes.func,
  showPayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  getValidCompanyName: PropTypes.func.isRequired,
};
AddCompanySummary.defaultProps = {
  summaryDetails: {},
  companyData: {},
  content: {},
};

export default AddCompanySummary;
